import { Capacitor } from "@capacitor/core";

export const isNative = () => Capacitor.isNativePlatform();

// Opens the supermarket inside the app and injects Millie's helper — no bookmark needed.
export async function runNativeTrolley({ openUrl, helperKey, onClosed }) {
  const { InAppBrowser } = await import("@capgo/capacitor-inappbrowser");
  const apiBase = process.env.REACT_APP_BACKEND_URL;
  const inject = `
    (function(){
      if (window.__sortedHelper) { window.__sortedHelper.open(); return; }
      window.__SORTED_API = ${JSON.stringify(apiBase)};
      window.__SORTED_KEY = ${JSON.stringify(helperKey)};
      var s = document.createElement('script');
      s.src = ${JSON.stringify(apiBase)} + '/api/trolley/helper.js?k=' + encodeURIComponent(${JSON.stringify(helperKey)}) + '&_=' + Date.now();
      document.documentElement.appendChild(s);
    })();`;
  const loaded = await InAppBrowser.addListener("browserPageLoaded", async () => {
    try { await InAppBrowser.executeScript({ code: inject }); } catch { /* page still settling; user can tap Millie button */ }
  });
  const closed = await InAppBrowser.addListener("closeEvent", () => { loaded.remove(); closed.remove(); onClosed?.(); });
  await InAppBrowser.openWebView({
    url: openUrl,
    title: "Millie's trolley helper",
    toolbarColor: "#FFF6F1",
    toolbarTextColor: "#3A2B2F",
    showReloadButton: true,
    closeModal: false,
    isPresentAfterPageLoad: true,
    preShowScript: inject,
    preShowScriptInjectionTime: "pageLoad",
  });
}
